<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import EmployeeActivityBase from '../../../../../employee_activity/components/EmployeeActivityBase.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <EmployeeActivityBase />
</template>